'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _siteHeader = require('./site-header');

var _siteHeader2 = _interopRequireDefault(_siteHeader);

var _tabs = require('./tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _sectionCloser = require('./section-closer');

var _sectionCloser2 = _interopRequireDefault(_sectionCloser);

var _chat = require('./chat');

var _chat2 = _interopRequireDefault(_chat);

var _serviceAssistent = require('./service-assistent');

var _serviceAssistent2 = _interopRequireDefault(_serviceAssistent);

var _article = require('./article');

var _article2 = _interopRequireDefault(_article);

var _trackAndTrace = require('./track-and-trace');

var _trackAndTrace2 = _interopRequireDefault(_trackAndTrace);

var _waitingTime = require('./waiting-time');

var _waitingTime2 = _interopRequireDefault(_waitingTime);

var _contentFilter = require('./content-filter');

var _contentFilter2 = _interopRequireDefault(_contentFilter);

var _cbStickyReceipt = require('./cb-sticky-receipt.directive');

var _cbStickyReceipt2 = _interopRequireDefault(_cbStickyReceipt);

var _cbCollapse = require('./cb-collapse.directive');

var _cbCollapse2 = _interopRequireDefault(_cbCollapse);

var _cbDatepicker = require('./cb-datepicker.directive');

var _cbDatepicker2 = _interopRequireDefault(_cbDatepicker);

var _cbContentSlider = require('./cb-content-slider.directive');

var _cbContentSlider2 = _interopRequireDefault(_cbContentSlider);

var _cbContentVideo = require('./cb-content-video.directive');

var _cbContentVideo2 = _interopRequireDefault(_cbContentVideo);

var _cbContentAccordion = require('./cb-content-accordion.directive');

var _cbContentAccordion2 = _interopRequireDefault(_cbContentAccordion);

var _cbContentAccordionSmall = require('./cb-content-accordion-small.directive');

var _cbContentAccordionSmall2 = _interopRequireDefault(_cbContentAccordionSmall);

var _cbProgressBar = require('./cb-progress-bar.component');

var _cbProgressBar2 = _interopRequireDefault(_cbProgressBar);

var _cbCarousel = require('./cb-carousel.directive');

var _cbCarousel2 = _interopRequireDefault(_cbCarousel);

var _cbCalamiteitenBanner = require('./cb-calamiteiten-banner.directive');

var _cbCalamiteitenBanner2 = _interopRequireDefault(_cbCalamiteitenBanner);

var _vragenboom = require('./vragenboom');

var _vragenboom2 = _interopRequireDefault(_vragenboom);

var _slideshow = require('./slideshow');

var _slideshow2 = _interopRequireDefault(_slideshow);

var _cbFoldOut = require('./fold-out/cb-fold-out.component');

var _cbFoldOut2 = _interopRequireDefault(_cbFoldOut);

var _disclaimer = require('./disclaimer');

var _disclaimer2 = _interopRequireDefault(_disclaimer);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _fullscreen = require('./fullscreen');

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _callMeNow = require('./call-me-now');

var _callMeNow2 = _interopRequireDefault(_callMeNow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components', [_form2.default.name, _siteHeader2.default.name, _tabs2.default.name, _sectionCloser2.default.name, _chat2.default.name, _article2.default.name, _modal2.default.name, _fullscreen2.default.name, _serviceAssistent2.default.name, _trackAndTrace2.default.name, _waitingTime2.default.name, _cbStickyReceipt2.default.name, _cbCollapse2.default.name, _cbDatepicker2.default.name, _cbContentSlider2.default.name, _cbContentVideo2.default.name, _cbContentAccordion2.default.name, _cbContentAccordionSmall2.default.name, _cbProgressBar2.default.name, _cbCarousel2.default.name, _contentFilter2.default.name, _cbCalamiteitenBanner2.default.name, _vragenboom2.default.name, _slideshow2.default.name, _cbFoldOut2.default.name, _disclaimer2.default.name, _callMeNow2.default.name]);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/index.js
// module id = 893
// module chunks = 0